<template>
  <Pie
    v-bind:chart-data="chartData"
    v-bind:chart-options="chartOptions"
    ref="chart"
  />
</template>

<script>
import { Pie } from 'vue-chartjs/legacy';

/**
 * @description Генератор цветов
 * @return {Generator<string, void, *>}
 */
function* colorGenerator() {
  const colors = [
    '#0489E0',
    '#ff0000',
    '#D9E1EC',
    '#7371FF',
    '#EC782A',
    '#28b600',
    '#7f00af',
  ];
  let i = 0;
  while (i < colors.length) {
    const color = colors[i];
    yield color;
    i += 1;
    if (i === colors.length) {
      i = 0;
    }
  }
}

export default {
  name: 'SalesCircle',
  components: {
    Pie,
  },
  computed: {
    chartData() {
      return {
        labels: this.items.map((item) => item[this.itemLabelKey]),
        datasets: [
          {
            backgroundColor: this.backgroundColors,
            data: this.items.map((item) => item[this.itemValueKey]),
          },
        ],
      };
    },
    backgroundColors() {
      let i = 0;
      const colors = [];
      const colorVendor = colorGenerator();
      while (i < this.items.length) {
        colors.push(colorVendor.next().value);
        i += 1;
      }
      return colors;
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: this.plugins,
      },
    };
  },
  props: {
    items: { type: Array, default: () => [] },
    itemLabelKey: { type: String, default: () => 'label' },
    itemValueKey: { type: String, default: () => 'value' },
    plugins: { type: Object, default: () => {} },
  },
};

</script>
